<span class="icon-inline" v-tooltip.bottom="tooltipOptions">
  <ChessDoublesSvg preserveAspectRatio="xMidYMid meet" :style="svgStyle" />
</span>
